import { useState } from 'react';
import { Button, Modal, ModalActions, ModalFootNote } from '../../../components/shared';
import { WidgetPickerPane } from './WidgetPickerPane';

/**
 * 위젯 추가 창 — 정본 F1 `picker`(좌 고르기 · 우 상세).
 *
 * ★★★ 종전에는 카드 격자에 **손으로 그린 도형**만 있어서 「이름만 봐서는 어떤 화면인지」
 *     알 수 없었다(2026-09-09 사용자 지적). 이제 오른쪽에 **진짜 위젯**이 선다.
 * ★ 이 창은 **두 곳이 함께 쓴다** — 대시보드의 「위젯 추가」와 통합설정의 「위젯 관리」.
 *   목록·미리보기·문구가 두 벌로 갈라지지 않게 담는 곳만 콜백으로 갈아 끼운다.
 * ★ 확인 단추의 이름은 **다음에 일어나는 일**이다(정본 F1 규율 ④).
 */
export interface WidgetPickerModalProps {
  /** 이미 얹혀 있는 위젯 key — 표시만 다르게. */
  alreadyOn?: string[];
  /** 고른 것을 어디에 담을지는 부르는 쪽이 정한다. */
  onConfirm: (keys: string[]) => void;
  onClose: () => void;
  /** 확인 단추 이름 — 「대시보드에 올리기」 · 「기본판에 넣기」. */
  confirmLabel?: string;
}

export function WidgetPickerModal({ alreadyOn = [], onConfirm, onClose, confirmLabel = '대시보드에 올리기' }: WidgetPickerModalProps) {
  const [selected, setSelected] = useState<string[]>([]);

  const toggle = (key: string) => setSelected((cur) => (
    cur.includes(key) ? cur.filter((k) => k !== key) : [...cur, key]
  ));

  return (
    <Modal
      title="위젯 추가"
      size="md"
      onClose={onClose}
      footer={(
        <>
          <ModalFootNote>위젯 <b>{selected.length}</b>개 담김</ModalFootNote>
          <ModalActions>
            <Button variant="secondary" onClick={onClose}>취소</Button>
            <Button
              variant="primary"
              disabled={selected.length === 0}
              onClick={() => { onConfirm(selected); onClose(); }}
            >
              {confirmLabel}{selected.length > 0 ? ` (${selected.length})` : ''}
            </Button>
          </ModalActions>
        </>
      )}
    >
      <WidgetPickerPane selected={selected} onToggle={toggle} alreadyOn={alreadyOn} />
    </Modal>
  );
}
